import { render, staticRenderFns } from "./ChangeLogDetail.vue?vue&type=template&id=1d08b592&"
import script from "./ChangeLogDetail.vue?vue&type=script&lang=js&"
export * from "./ChangeLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLogDetail.vue?vue&type=style&index=0&id=1d08b592&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports